import { IncomingMessage } from "http";

import { NextRequest } from "next/server";

/**
 * Extract the client IP address from either a NextRequest (middleware)
 * or IncomingMessage (Next.js page context)
 */
export function getClientIp(
  request: NextRequest | IncomingMessage
): string | null {
  // Handle NextRequest (middleware)
  if ("nextUrl" in request) {
    const nextRequest = request as NextRequest;
    return (
      // Fallback
      // First in list is client IP
      (nextRequest as any).ip ?? // May be populated automatically in production (e.g. Vercel)
      nextRequest.headers.get("x-forwarded-for")?.split(",")[0]?.trim() ??
      nextRequest.headers.get("x-real-ip")
    );
  }

  // Handle IncomingMessage (Next.js page context)
  // Priority order for IP headers
  const headerNames = ["cf-connecting-ip", "x-forwarded-for", "x-real-ip"];
  const incomingMessage = request as IncomingMessage;
  for (const headerName of headerNames) {
    const headerValue = incomingMessage.headers[headerName];
    if (headerValue) {
      const ip = Array.isArray(headerValue) ? headerValue[0] : headerValue;
      // For x-forwarded-for, take the first IP in the comma-separated list
      return headerName === "x-forwarded-for" ? ip.split(",")[0].trim() : ip;
    }
  }

  // Fallback to socket remote address for IncomingMessage
  if ("socket" in incomingMessage && incomingMessage.socket?.remoteAddress) {
    return incomingMessage.socket.remoteAddress;
  }

  return null;
}
